export default __webpack_public_path__ + "static/media/Flag_of_China.ff80d681.svg";